import { CommonModule } from "@angular/common";
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  signal,
  SimpleChanges,
} from "@angular/core";
import { ICustomerOverview } from "@rfm/shared-interfaces";
import { CardModule } from "primeng/card";

@Component({
  selector: "app-payment-history",
  standalone: true,
  imports: [CommonModule, CardModule],
  templateUrl: "./payment-history.component.html",
  styleUrls: ["./payment-history.component.scss"],
})
export class PaymentHistoryComponent implements OnInit, OnChanges {
  @Input()
  customer_overview = signal<ICustomerOverview | undefined>(undefined);

  hasPayments: boolean = false;

  constructor() {}
  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.customer_overview() &&
      this.customer_overview()?.payments &&
      this.customer_overview()?.payments?.data &&
      this.customer_overview()?.payments?.data.length! > 0
    ) {
      this.hasPayments = true;
    }
  }

  ngOnInit() {}
}
